import { Booking, tnePackages } from '../../../../requests-module/src';

function checkIsTnePackage(booking: Booking | null | undefined): boolean {
    const packageCode = booking?.packageCode;
    if (!packageCode) return false;
    return tnePackages.some((pkg) => packageCode === pkg || packageCode.startsWith(`${pkg}_`));
}

export default checkIsTnePackage;
